import { z } from "zod";

export const FeedbackSchema = z.object({
	subjects_list: z.array(
		z.object({
			name: z.string(),
			_id: z.string(),
		})
	),
	content: z.string(),
	shared_with: z.string(),
});

export type FeedbackAttributes = "notes" | "notesManager" | "allowRecognition" | "allowOneOne" | "allowSubjectManager";

export const calculateShareOptions = ({
	value,
	attributes,
	selectedUsers,
	currentUser,
}: {
	value: string;
	attributes: { [key in FeedbackAttributes]: boolean };
	selectedUsers: string[];
	currentUser: string;
}) => {
	const onlyCurrentUser = selectedUsers.length === 1 && selectedUsers[0] === currentUser;
	const options: {
		isSelected: boolean;
		inactive: false;
		value: string;
		label: string;
		tag: string;
		description: string;
	}[] = [];

	if (onlyCurrentUser) {
		if (attributes["notesManager"]) {
			options.push({
				isSelected: value === "subject-manager",
				inactive: false,
				value: "subject-manager",
				label: "Your manager",
				tag: "Recognition",
				description: "This will be shared with your manager.",
			});
		}
	} else {
		if (attributes["allowRecognition"]) {
			options.push({
				isSelected: value === "everyone",
				inactive: false,
				value: "everyone",
				label: "Entire Company (Recognition)",
				tag: "Recognition",
				description: "This will be shared with the entire company.",
			});
		}

		if (attributes["allowOneOne"]) {
			options.push({
				isSelected: value === "subject",
				inactive: false,
				value: "subject",
				label: `Subject${selectedUsers.length > 1 ? "s" : ""}`,
				tag: "Recognition",
				description: `This will be shared with the subject${selectedUsers.length > 1 ? "s" : ""}.`,
			});
		}

		//Triple Check this one
		if (attributes["subjectManager"]) {
			options.push({
				isSelected: value === "subject-manager",
				inactive: false,
				value: "subject-manager",
				label: `Only Subject${selectedUsers.length > 1 ? "s'" : "'s"} Manager`,
				tag: "Recognition",
				description: `This will be shared with the subject${selectedUsers.length > 1 ? "s" : ""} manager${selectedUsers.length > 1 ? "s" : ""}.`,
			});
		}

		if (attributes["subjectManager"] && attributes["allowOneOne"]) {
			options.push({
				isSelected: value === "subject-+-manager",
				inactive: false,
				value: "subject-+-manager",
				label: selectedUsers.length > 1 ? "Subjects and Subjects' Managers" : "Subject and Subject's Manager",
				tag: "Recognition",
				description: "",
			});
		}
	}

	if (attributes["notes"]) {
		options.push({
			isSelected: value === "me",
			inactive: false,
			value: "me",
			label: "Do Not Share",
			tag: "Private Note",
			description: "This note will be kept private to you.",
		});
	}

	return options;
};

export const feedbackPermissionsMap = {
	me: ["notes"],
	"subject-manager": ["notesManager", "allowSubjectManager"],
	everyone: ["allowRecognition"],
	subject: ["allowSubject"],
	"subject-+-manager": ["allowSubjectManager"],
};

export const getSubmitButtonLabel = (sharedWith = "", onlyCurrentUser = false) => {
	let label = "Give Feedback";

	if (sharedWith === "me") {
		label = "Save Note";
	} else if (onlyCurrentUser && sharedWith === "subject-manager") {
		label = "Send Note";
	} else if (onlyCurrentUser) {
		label = "Add to Notes";
	} else if (sharedWith === "everyone") {
		label = "Give Recognition";
	}

	return label;
};
